<template>
  <!-- Aqui que se evalue las opciones que el componente va a renderizar tambien la parta del action 
  buscar una estrategia para afinar este componente y se reuse :D-->
  <div>
    <li class="nav-item dropdown custom-dropdown">
      <button
        v-show="showBox"
        v-if="greenStyle"
        :class="
          `btn btn-dropdown-actions dropdown-toggle pt-1 dropdown__actions--${title.color}`
        "
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <em :class="[`${title.icon} pr-1`, title.color]" />
        <span :class="title.color">{{ title.name || 'Acciones' }}</span>
      </button>
      <a
        v-else
        v-show="showBox"
        id="navbarDropdown"
        class="nav-link dropdown-toggle action-button"
        :class="{ 'dropdown-normal-size': normalSize }"
        href="#"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        @click="collapseMenu(false)"
      >
        <i class="fa fa-angle-down" />
        <span>{{ title.name }}</span>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <form
          :id="idForm"
          :class="[{ 'form-width-300': fixWidth, 'form-width': !fixWidth }]"
        >
          <div
            v-for="(item, index) in Actions"
            :id="`accordion-${index}`"
            :key="`item-${index}`"
            :class="item.Variant"
          >
            <!-- {{item}} -->
            <div v-if="item.Visible || item.Visible == undefined">
              <a
                :class="{
                  'bg-parent': item.Children.length > 0,
                  hidden: item.Visible !== undefined && !item.Visible,
                }"
                class="nav-link nav-items"
                style="cursor:pointer"
                aria-expanded="false"
                @click="eventHandle(item.EmitGo, item.Item)"
              >
                <i
                  v-if="item.Icon !== ''"
                  class="mr-1"
                  :class="item.Icon + ' ' + item.IconColor"
                />
                <span class="item-title">{{ item.Title | trim }}</span>
              </a>
            </div>
            <!-- && item.children.every(c=> c.Visible == false)  (Que al menos un hijo sea verdadero)-->
            <div
              v-if="item.Visible || item.Visible == undefined"
              :id="`collapse-${index}`"
              :data-target="`#collapse-${index}`"
              style="cursor:pointer"
              :data-parent="`#accordion-${index}`"
            >
              <div
                v-for="(children, indexChildren) in item.Children"
                :key="`item-${indexChildren}`"
              >
                <template
                  v-if="children.Visible || children.Visible == undefined"
                >
                  <a
                    class="collapse-item"
                    style="cursor:pointer"
                    @click="eventHandle(children.EmitGo, children.Item)"
                  >
                    <div class="nav-link nav-items">
                      <i
                        v-if="children.Icon !== ''"
                        class="mr-1"
                        :class="children.Icon + ' ' + children.IconColor"
                      />
                      <span>{{ children.Title | trim }}</span>
                    </div>
                  </a>
                </template>
              </div>
            </div>
            <div
              v-if="item.HasLine && (item.Visible || item.Visible == undefined)"
              class="dropdown-divider dropdown-divider-extended w-90 ml-3 mb-0"
            />
          </div>
        </form>
      </div>
    </li>
  </div>
</template>
<script>
export default {
  name: 'SquareOption',
  meta: {
    description: 'Componente para botón con opciones desplegables.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    title: {
      type: Object,
      default: () => ({}),
    },
    actions: {
      type: Array,
      default: () => {},
      meta: {
        description: 'Establece el comportamiento',
        example: '[4, 8, 15, 16, 23, 42]',
      },
    },
    greenStyle: {
      type: Boolean,
      default: true,
      meta: {
        description: 'Propiedad de estilos',
        example: 'true',
      },
    },
    fixWidth: {
      type: Boolean,
      default: true,
      meta: {
        description: 'Establece un ancho fijo al componente',
        example: 'true',
      },
    },
    hideWithoutItems: {
      type: Boolean,
      default: () => false,
    },
    items: {
      type: Array,
      default: () => [
        {
          Title: {
            type: String,
            default: '',
            required: true,
          },
          Icon: {
            type: String,
            default: '',
            required: true,
          },
          IconColor: {
            type: String,
            default: '',
            required: false,
          },
          EmitGo: {
            type: String,
            default: '',
            required: false,
          },
          // This object than works like parameter
          Item: {
            type: Object,
            default: () => {},
            required: false,
          },
          Visible: {
            type: Boolean,
            default: () => true,
          },
          Children: {
            type: Array,
            required: false,
            default: [
              {
                Title: {
                  type: String,
                  default: '',
                },
                Icon: {
                  type: String,
                  default: '',
                },
                IconColor: {
                  type: String,
                  default: '',
                },
                EmitGo: {
                  type: String,
                  default: '',
                },
                Item: {
                  type: Object,
                  default: () => {},
                  required: false,
                },
                Visible: {
                  type: Boolean,
                  default: true,
                  required: false,
                },
              },
            ],
          },
          Variant: {
            type: String,
            default: '',
          },
          HasLine: {
            type: Boolean,
            default: () => false,
          },
        },
      ],
      meta: {
        description: 'Establece título, icono y color del componente',
        example: 'itemsDropdown',
      },
    },
    normalSize: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    idForm() {
      return `form-menu-${this._uid}`;
    },
  },
  data() {
    return {
      Actions: this.items,
      showBox: true,
    };
  },
  methods: {
    eventHandle: function(action, parameter) {
      if (action !== undefined) {
        this.$emit(action, parameter);
      }
    },
    collapseMenu(status) {
      this.isMenu = status;
    },
    canShowBox(items) {
      if (!this.hideWithoutItems) return;
      this.showBox = items.some((x) => x.Visible || x.Visible == null);
      this.$forceUpdate();
    },
  },
  mounted() {
    this.canShowBox(this.items);
  },
  watch: {
    items: {
      handler(nw) {
        this.Actions = nw;
        this.canShowBox(nw);
      },
      deep: true,
    },
  },
  filters: {
    trim(value) {
      if (typeof value == 'string') {
        return value.trim();
      }
      return value;
    },
  },
};
</script>

<style scoped>
.dropdown a.btn {
  border: none;
}

.dropdown__actions--text-green::after {
  color: #2db782 !important;
}

.nav-link-custom {
  padding-left: 55px;
  margin-top: 5px;
}
.bg-parent {
  background-color: #f7f7f7;
  box-shadow: 0px 3px 6px #00000029;
}
a:hover:not(.bg-parent) {
  background-color: #f7f7f7;
  cursor: pointer;
}

/* Set el css Para el arrown HERE  */
.dropdown a i {
  border-radius: 4px;
  padding-bottom: 10px;
}
.dropdown a::after {
  content: none;
}
.dropdown-detail {
  padding: 4px 45px;
}
.hidden {
  display: none;
}
.custom-dropdown {
  display: block;
}
.collapse-item {
  float: left;
  width: 100%;
  padding-left: 15px;
}
a.collapse-item {
  padding-top: 10px;
}
.collapse-item i {
  float: left;
}
.nav-items {
  font-size: 15px;
  padding: 10px 5px 10px 15px;
  cursor: pointer;
  min-height: 2.14em;
  color: #11291b;
}
.form-width {
  width: 100%;
}
.form-width-300 {
  width: 300px;
}
.nav-link .nav-items {
  font-size: 15px;
  padding: 5px 5px 5px 15px;
}
.action-button {
  border: 1px solid #2db782;
  border-radius: 4px;
  padding: 13px 13px 13px 32px;
  text-align: left;
  max-width: 150px;
  margin: auto;
}
#navbarDropdown i {
  float: right;
}
.dropdown-divider-extended {
  padding-top: 0px;
  margin-top: 3px;
}

.dropdown-normal-size {
  height: 36px;
  max-width: 125px;
  padding-top: 8px;
}

.dropdown-normal-size i {
  margin-top: 3px;
}

.dropdown-normal-size span {
  margin-left: -9px;
}

.item-title {
  margin-left: 10px;
}
</style>
